import React from 'react';
import Grid from '@mui/material/Grid';
import Sidebar from '../components/sidebar/sidebar';
import { useTranslation } from 'react-i18next';
export default function Layout({ children }) {

  const { i18n } = useTranslation();



  return (
    <Grid container>

      <Grid item md={9.7} sx={{height:"100vh"}}>
        {children}
      </Grid>
      <Grid item md={3}>
        <Sidebar />
      </Grid>
    </Grid>


    // <div>
    //   {children}
    //   <Sidebar />
    // </div>
  );
}